// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rMMRf","name":"styles_name__1l9ph","phone":"styles_phone__1U7mG"};